import React, { useEffect, useState } from "react";
import post1 from "./../images/post-1.png";
import post2 from "./../images/post-2.png";
import post3 from "./../images/post-3.png";
import post4 from "./../images/post-4.png";
import "./Blog.css";
import {motion,AnimatePresence} from "framer-motion"
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Media from "./Media";
const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    axios
      .get("https://back.waratechnology.com/api/blog/getblog")
      .then((res) => {
      
        setBlogs(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ y: 10, opacity: 1 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -10, opacity: 1 }}
        transition={{ duration: 0.2 }}
        id="blog"
        className="blog_area mb-8 w-full pt-120"
      >
        <div className="page-hero pt-20 pb-4">
          <div className=" mx-auto max-w-[768px] text-center">
            <h1 className="mb-5 mt-8 text-3xl md:text-4xl lg:text-6xl  font-bold font-play">
              Our recent blogs
            </h1>
          </div>
        </div>

        <section className="section pt-0">
          <div className="container">
            <div className="flex flex-wrap gap-8">
              {blogs.map((data, index) => (
                // <div className="rounded-xl bg-white p-6 shadow-lg lg:p-8">
                //   <div className="flex  flex-col md:flex-row  gap-4">
                //     <img
                //       className="rounded-xl h-80 relative lg:max-h-96 w-full lg:max-w-96"
                //       width="235"
                //       height="304"
                //       src={"http://localhost:3010" + data.blog_image}
                //       alt=""
                //     />
                //     <div className="card-content items-center mt-4 md:mt-12">
                //       <h3 className="h4 mb-4 text-2xl font-semibold font-play">
                //         {data.blog_highlight}
                //       </h3>
                //       <p className="text-[#575656] font-normal font-sans text-base md:text-lg lg:text-xl">
                //         {data.blog_description}
                //       </p>
                //       <div className="card-footer mt-6 flex space-x-4">
                //         <span className="inline-flex items-center text-[#575656] font-normal font-sans text-base md:text-lg lg:text-xl">
                //           <svg
                //             className="mr-1.5"
                //             width="14"
                //             height="16"
                //             viewBox="0 0 14 16"
                //             fill="none"
                //             xmlns="http://www.w3.org/2000/svg"
                //           >
                //             <path
                //               d="M12.5 2H11V0.375C11 0.16875 10.8313 0 10.625 0H9.375C9.16875 0 9 0.16875 9 0.375V2H5V0.375C5 0.16875 4.83125 0 4.625 0H3.375C3.16875 0 3 0.16875 3 0.375V2H1.5C0.671875 2 0 2.67188 0 3.5V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V3.5C14 2.67188 13.3281 2 12.5 2ZM12.3125 14.5H1.6875C1.58438 14.5 1.5 14.4156 1.5 14.3125V5H12.5V14.3125C12.5 14.4156 12.4156 14.5 12.3125 14.5Z"
                //               fill="#939393"
                //             />
                //           </svg>
                //           {data.blog_date}
                //         </span>
                //       </div>
                //     </div>
                //   </div>
                // </div>

                <div class="max-w-sm bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-white dark:border-gray-100">
                  <a href="#">
                    <img
                      class="rounded-t-lg"
                      src={"http://localhost:3010" + data.blog_image}
                      alt=""
                    />
                  </a>
                  <div class="p-5">
                    <a href="#">
                      <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 font-play">
                        {data.blog_highlight}
                      </h5>
                    </a>
                    <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">
                      {data.blog_description}
                    </p>
                    <a
                      href="#"
                      class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-[#f7b53b] rounded-lg hover:bg-[#ebad39] focus:ring-4 focus:outline-none focus:ring-blue-300"
                    >
                      Read more
                      <svg
                        class="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 10"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M1 5h12m0 0L9 1m4 4L9 9"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* <Media /> */}
      </motion.div>
    </AnimatePresence>
  );
};

export default Blog;
